import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TextHighlighted } from '@playbookux/playbook-web-core';
import { formatEntityType } from '../../../utils/format-entity-type';

import Card from '../../card-highlight';

const HighlightCard = (props) => {
  const {
    handleClick,
    highlight,
    searchHighlights,
    isSelectable,
    selected,
    onCardClick,
  } = props;

  const { searchable } = highlight || {};

  const {
    createdAt,
    entityType = '',
    noteType,
    tag,
    project,
    id,
    entity,
    charStart,
    charEnd,
  } = searchable;

  const {
    testSession,
    note: textNote = null,
    transcriptText: textAnswer = null,
    text: textSpeaker = null,
    videoStartTime = null,
  } = entity || {};

  const firstName = _.get(testSession, 'tester.user.profile.firstName', '');
  const tagName = _.get(tag, 'name', '');
  const color = _.get(tag, 'tagGroup.color', '');
  const tagType = _.get(tag, 'tagType', '');
  const testerId = _.get(testSession, 'tester.id', '');

  const textHighlight = useMemo(() => {
    if (!textNote && !textAnswer && !textSpeaker) return '';

    const newText = textNote || textAnswer || textSpeaker;

    return newText.substring(charStart, charEnd + 1);
  }, [charStart, charEnd, textNote, textAnswer, textSpeaker]);

  const tagHighlights = [{
    charStart: 0,
    charEnd: textHighlight.length,
    entityType,
    id,
    tag,
  }];

  const url = `projects/${project.id}/videos/${testerId}?time=${videoStartTime}`;
  const cardType = formatEntityType(entityType, noteType);

  return (
    <Card
      cardType={cardType}
      color={color}
      createdAt={createdAt}
      isFiltered
      isSelectable={isSelectable}
      onCardClick={onCardClick}
      onClick={() => handleClick('entityId', entityType, url)}
      projectName={project.name}
      selected={selected}
      tagName={tagName}
      tagType={tagType}
      userName={firstName}
    >
      <TextHighlighted
        tagHighlights={tagHighlights}
        text={textHighlight || ''}
        searchHighlights={searchHighlights}
      />
    </Card>
  );
};

HighlightCard.propTypes = {
  handleClick: PropTypes.func.isRequired,
  searchHighlights: PropTypes.arrayOf(PropTypes.shape({
    charEnd: PropTypes.number,
    charStart: PropTypes.number,
    text: PropTypes.string,
  })),
  selected: PropTypes.bool.isRequired,
  onCardClick: PropTypes.func,
  isSelectable: PropTypes.bool,
  highlight: PropTypes.shape({
    searchable: PropTypes.shape({
      id: PropTypes.string,
      createdAt: PropTypes.string,
      entityType: PropTypes.string,
      noteType: PropTypes.string,
      createdBy: PropTypes.shape({
        profile: PropTypes.shape({
          firstName: PropTypes.string,
        }),
      }),
      tag: PropTypes.shape({
        id: PropTypes.string,
        tagType: PropTypes.string,
        name: PropTypes.string,
      }),
      project: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
  }).isRequired,
};

HighlightCard.defaultProps = {
  isSelectable: false,
  onCardClick: () => { },
  searchHighlights: [],
};

export default HighlightCard;
